import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { resetPassword } from '../controllers/user';
import { Link, useSearchParams } from 'react-router-dom';
import { useToast } from '../components/toast/ToastContext';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [valid, setValid] = useState(false);
  const [success, setSuccess] = useState(false);
  const showToast = useToast();

  useEffect(() => {
    document.title = 'FAMA - Nueva Contraseña';
  }, []);

  useEffect(() => {
    const trimmedPass1 = password.trim();
    const trimmedPass2 = password2.trim();
    if (trimmedPass1 && trimmedPass2) {
      if (trimmedPass1 === trimmedPass2) {
        setValid(true);
      }
      else {
        setValid(false);
      }
    }
    else {
      setValid(false);
    }
  }, [password, password2]);

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      await resetPassword(token, password);
      showToast({
        message: 'Se ha actualizado la contraseña correctamente.',
        bg: 'success',
        autohide: true,
        delay: 7000,
        title: 'Contraseña actualizada'
      });
      setSuccess(true);
    }
    catch (e) {
      console.log(e);
      if (e.status === 400) {
        showToast({
          message: 'El token no es válido.',
          bg: 'danger',
          autohide: true,
          delay: 7000,
          title: 'Error al actualizar contraseña'
        });
      }
      else {
        showToast({
          message: 'Ocurrió un error. Por favor intenta de nuevo más tarde.',
          bg: 'danger',
          autohide: true,
          delay: 7000,
          title: 'Error al actualizar contraseña'
        });
      }
      
    }
  }

  if (!token) {
    return <Container>
      <Row className='justify-content-md-center p-4'>
        <Col md={4}>Falta información necesaria para procesar este pedido.</Col>
      </Row>
    </Container>
  }

  return (
    <Container>
      <Row className='justify-content-md-center p-4'>
        <Col md={4}>
          <h1>Nueva contraseña</h1>
          <Form className='mt-4 mb-4' onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Contraseña</Form.Label>
              <Form.Control type="password" placeholder="Contraseña" value={password} onChange={e => setPassword(e.target.value)} required />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Confirma la contraseña</Form.Label>
              <Form.Control type="password" placeholder="Confirma Contraseña" value={password2} onChange={e => setPassword2(e.target.value)} required />
            </Form.Group>
            {valid && <Button variant="primary" type="submit">
              Enviar
            </Button>}
          </Form>
          <p><Link to={'/login'}>Iniciar sesión</Link></p>
          <p>¿Aún no tienes cuenta? <Link to={'/registro'}>Crea una cuenta nueva</Link>.</p>
        </Col>
      </Row>
    </Container>
  );
}

export default ResetPassword;
